import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Megaphone } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchAdPosts, GROUP_OPS_STR as S, type AdPostRow } from './groupOpsApi'

/**
 * A4.18 — Kanal broadcast postlari. REAL: `/admin/group-ops/ad-posts` — kanal
 * xabarlari + qamrov (a'zolar soni). MyGram'da homiylik/reklama posti tushunchasi
 * yo'q → kanal broadcast postlari halol ko'rsatiladi.
 */
export function GroupAdPosts() {
  const columns = useMemo<AdminColumn<AdPostRow>[]>(
    () => [
      {
        key: 'group_title',
        header: S.channel,
        type: 'text',
        width: 200,
        render: (r) => (
          <Link to={`/groups/${r.group_id}`} className="text-accent hover:underline">
            {r.group_title || `#${r.group_id}`}
          </Link>
        ),
      },
      { key: 'sender', header: S.sender, type: 'text', width: 150 },
      { key: 'text', header: S.message, type: 'longtext', minWidth: 240 },
      { key: 'reach', header: S.reach, type: 'number', width: 140, align: 'right' },
      { key: 'created_at', header: S.created, type: 'date', width: 160 },
    ],
    [],
  )
  const fetcher = useCallback(fetchAdPosts, [])
  return (
    <>
      <PageHeader title={S.adPosts} screenId="A4.18" description={S.adPostsNote} />
      <DataTable<AdPostRow>
        screenId="A4.18"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Megaphone size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
